import { h, Component } from 'preact';
import style from './index.less'

export default (props)=>(
    <div class={style.divider}>
        <span class={style.name}>
            {props.children}
        </span>
    </div>
)


// WEBPACK FOOTER //
// ./components/elements/Divider/index.js